import { Client } from '../../domain/ClientSlice/Client';
import { ClientUpdateClientMe } from '../../domain/ClientSlice/ClientUpdateClientMe';
import ApiWrapperAuthenticated from '../Common/ApiWrapperAuthenticated';

export class ClientMeRepository extends ApiWrapperAuthenticated<Client, void, ClientUpdateClientMe> {
    constructor() {
        super('clients/me/');
    }
}
